// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qqqm","toggleWrap":"styles_toggleWrap__1bsWF","content":"styles_content__32hRl","selectAreaCode":"styles_selectAreaCode__2Q_Xj"};